/**
 * EN / ID switch for /new.
 *
 * The language is guessed from the browser (see regionCopy.ts), and the guess
 * is wrong for a large, important group: Indonesian creators running an
 * English phone. Rather than second-guess them from an IP address, this makes
 * the choice one tap and remembers it.
 */

import React from 'react'
import { useLang, setLang, type Lang } from '../regionCopy'

const OPTIONS: { value: Lang; label: string }[] = [
  { value: 'en', label: 'EN' },
  { value: 'id', label: 'ID' }
]

interface LangToggleProps {
  /** 'bar' for the navbar, 'rail' for the compact step header. */
  variant?: 'bar' | 'rail'
}

export const LangToggle: React.FC<LangToggleProps> = ({ variant = 'bar' }) => {
  const lang = useLang()
  const compact = variant === 'rail'

  return (
    <div
      role="group"
      aria-label="Language"
      className={`flex shrink-0 items-center gap-0.5 rounded-full border border-white/10 bg-white/[0.05] ${
        compact ? 'p-0.5' : 'p-1'
      }`}
    >
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => setLang(o.value)}
          aria-pressed={lang === o.value}
          className={`rounded-full font-semibold transition-colors ${
            compact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-[11px]'
          } ${
            lang === o.value
              ? 'bg-blueSparkle text-whiteout'
              : 'text-whiteout/50 hover:text-whiteout'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  )
}

export default LangToggle
